import { render, staticRenderFns } from "./PlpItems.vue?vue&type=template&id=43c225b4&scoped=true&"
import script from "./PlpItems.vue?vue&type=script&lang=js&"
export * from "./PlpItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c225b4",
  null
  
)

export default component.exports